import {
  Box,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Badge,
  HStack,
  Checkbox,
  TableContainer,
  Avatar,
} from '@chakra-ui/react';
import React from 'react';
import { MdMoreVert, MdVisibility, MdEdit, MdDelete } from 'react-icons/md';
import { usePermissions } from 'hooks/usePermissions';

const getTypeColor = (type) => {
  const colors = {
    'Dispositif Médical': 'red',
    'Pharmacie': 'green',
    'Autre': 'gray',
  };
  return colors[type] || 'gray';
};

export default function StockTable({
  tableData = [],
  selectedItems = [],
  onSelect = () => { },
  onView = () => { },
  onEdit = () => { },
  onDelete = () => { }
}) {
  const { hasPermission } = usePermissions();

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      onSelect(tableData.map(item => item.id));
    } else {
      onSelect([]);
    }
  };

  const handleSelectOne = (id, checked) => {
    if (checked) {
      onSelect([...selectedItems, id]);
    } else {
      onSelect(selectedItems.filter(item => item !== id));
    }
  };

  const allSelected = tableData.length > 0 && tableData.every(item => selectedItems.includes(item.id));
  const isIndeterminate = selectedItems.length > 0 && !allSelected;

  return (
    <TableContainer border="1px solid" borderColor="gray.200" borderRadius="12px" overflowX="auto" bg="white">
      <Table variant="simple" minW="1000px" sx={{ 'th, td': { borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'gray.200', whiteSpace: 'nowrap' }, 'th:last-child, td:last-child': { borderRight: 'none' }, 'tr:last-child td': { borderBottom: 'none' } }}>
        <Thead>
          <Tr bg="gray.50">
            <Th w="50px">
              <Checkbox
                isChecked={allSelected}
                isIndeterminate={isIndeterminate}
                onChange={handleSelectAll}
              />
            </Th>
            <Th w="80px" color="gray.400" fontSize="xs" textTransform="none">ID</Th>
            <Th minW="200px" color="gray.400" fontSize="xs" textTransform="none">Produit</Th>
            <Th w="150px" color="gray.400" fontSize="xs" textTransform="none">Type</Th>
            <Th w="150px" color="gray.400" fontSize="xs" textTransform="none">Quantité</Th>
            <Th w="180px" color="gray.400" fontSize="xs" textTransform="none">Date de création</Th>
            <Th w="80px" color="gray.400" fontSize="xs" textTransform="none">Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {tableData.map((row) => (
            <Tr key={row.id} _hover={{ bg: 'gray.50' }}>
              <Td>
                <Checkbox
                  isChecked={selectedItems.includes(row.id)}
                  onChange={(e) => handleSelectOne(row.id, e.target.checked)}
                />
              </Td>
              <Td fontWeight="medium" color="gray.700">{row.id}</Td>
              <Td>
                <Text fontWeight="semibold" color="gray.700">
                  {row.item}
                </Text>
              </Td>
              <Td>
                <Badge colorScheme={getTypeColor(row.type)} borderRadius="full" px={2} py={1}>
                  {row.type}
                </Badge>
              </Td>
              <Td>
                <Text fontWeight="700" color={Number(row.quantite) <= 5 ? 'orange.500' : 'green.500'}>
                  {row.quantite}
                </Text>
              </Td>
              <Td>
                <Text color="gray.600">
                  {row.created_at ? new Date(row.created_at).toLocaleDateString('fr-FR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                  }) : '-'}
                </Text>
              </Td>
              <Td>
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<MdMoreVert />}
                    variant="ghost"
                    size="sm"
                    aria-label='Options'
                  />
                  <MenuList>
                    <MenuItem icon={<MdVisibility />} onClick={() => onView(row)}>Voir</MenuItem>
                    {hasPermission('stock_edit') && (<MenuItem icon={<MdEdit />} onClick={() => onEdit(row)}>Modifier</MenuItem>)}
                    {hasPermission('stock_delete') && (<MenuItem icon={<MdDelete />} onClick={() => onDelete(row)} color="red.500">Supprimer</MenuItem>)}
                  </MenuList>
                </Menu>
              </Td>
            </Tr>
          ))}
          {tableData.length === 0 && (
            <Tr>
              <Td colSpan={7} textAlign="center" py={8} color="gray.500">
                Aucune donnée disponible
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
